import { render } from "./WhistleBlower.vue?vue&type=template&id=c3acd036&scoped=true"
import script from "./WhistleBlower.vue?vue&type=script&lang=js"
export * from "./WhistleBlower.vue?vue&type=script&lang=js"

import "./WhistleBlower.vue?vue&type=style&index=0&id=c3acd036&scoped=true&lang=scss"

import exportComponent from "/root/hr-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3acd036"]])

export default __exports__